import { render, staticRenderFns } from "./CsAsignacionesPresupuesto.vue?vue&type=template&id=415c17dc"
import script from "./CsAsignacionesPresupuesto.vue?vue&type=script&lang=js"
export * from "./CsAsignacionesPresupuesto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports